import { TASK_STATUSES as ALL_TASK_STATUSES, TODO_DONE_STATUSES } from '@/store/tasks/tasks.dto';

import type { EventEditStep, WizardStep } from './eventWizard.types';

// The review step is not listed here: it is always the one past the last visible step.
export const STEPS: readonly WizardStep[] = [
  { id: 'details', label: 'Details', hint: 'Name, date & description', required: true },
  { id: 'location', label: 'Location', hint: 'Where it happens', required: false },
  { id: 'audience', label: 'Audience', hint: "Who it's for", required: false },
  { id: 'plan', label: 'Plan Event', hint: 'Itinerary & tasks', required: false },
];

/** What the wizard calls itself when it is editing one step of an existing event. */
export const EDIT_TITLES: Record<EventEditStep, string> = {
  details: 'Edit Details',
  location: 'Edit Location',
  audience: 'Edit Audience',
};

export const LOCATION_OPTIONS = [
  { value: 'Miami, FL, USA', label: 'Miami, FL, USA' },
  { value: 'Fort Lauderdale, FL, USA', label: 'Fort Lauderdale, FL, USA' },
  { value: 'Palm Beach, FL, USA', label: 'Palm Beach, FL, USA' },
  { value: 'Newport, RI, USA', label: 'Newport, RI, USA' },
  { value: 'Annapolis, MD, USA', label: 'Annapolis, MD, USA' },
  { value: 'San Diego, CA, USA', label: 'San Diego, CA, USA' },
];

export const AUDIENCE_OPTIONS = [
  { id: 'guests', emoji: '✉️', label: 'Invite Guests', desc: 'Build a guest list for this event.' },
  {
    id: 'team',
    emoji: '⚓',
    label: 'Owners & Crew',
    desc: 'The owners and every crew member join automatically.',
  },
];

export const MAX_EVENT_DAYS = 14;

/**
 * The same two states every other task form outside the provider workflow offers
 * (`hideWorkflowStatuses`): a task planned on an event is either still to do or done.
 */
export const TASK_STATUSES = ALL_TASK_STATUSES.filter((s) => TODO_DONE_STATUSES.includes(s.id)).map(
  ({ id, label }) => ({ value: id, label }),
);
export const TASK_TYPES = [
  { value: 'boatservice', label: 'Vessel service' },
  { value: 'guestservice', label: 'Guest service' },
  { value: 'admin', label: 'Admin' },
  { value: 'safety', label: 'Safety' },
];
export const TASK_EQUIPMENT = [
  { value: '', label: 'None' },
  { value: 'tender', label: 'Tender' },
  { value: 'watertoys', label: 'Water toys' },
  { value: 'navigation', label: 'Navigation' },
  { value: 'engine', label: 'Engine' },
];
export const TASK_REPEATS = [
  { value: 'none', label: 'Do not repeat' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export const EVENT_TYPES = [
  { id: 'general', label: 'General', emoji: '📅', desc: 'All-purpose event for any occasion' },
  { id: 'guest', label: 'Guest Event', emoji: '🥂', desc: 'Curated experience for special guests' },
  {
    id: 'food',
    label: 'Food & Dining',
    emoji: '🍽️',
    desc: 'Culinary experiences and gourmet gatherings',
  },
  { id: 'voyage', label: 'Voyage', emoji: '⛵', desc: 'Private on-water journey or sea adventure' },
];
